import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'simple-react-router-redux';

import history from 'store/custom-history';

import createAuthMiddleware from './auth-middleware';

export const sagaMiddleware = createSagaMiddleware();

const middleware = [sagaMiddleware, routerMiddleware(history), createAuthMiddleware()];

/* istanbul ignore next */
if (process.env.NODE_ENV === 'development') {
  const { createLogger } = require('redux-logger');
  const invariant = require('redux-immutable-state-invariant').default;

  middleware.push(invariant());
  middleware.push(createLogger({ collapsed: true, predicate: () => !window.SKIP_LOGGER }));
}

export default middleware;
